export default __webpack_public_path__ + "static/Provider-Group-Use-Case-8656f6485fa7b73f7d64cedb16443d85.png";